export default __webpack_public_path__ + "static/media/LabTransferDbsl.87caf4c2.svg";